/**
 * The message to show for a failed API request: the server's own words when
 * its JSON error body carries them (`message`, else `error`), otherwise
 * `fallback`. A transport failure (no `data`), a body that is not an object,
 * or one that names no message all show `fallback`, so nothing technical such
 * as `TypeError: Failed to fetch` reaches the screen.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null || !("data" in error)) return fallback;
  const { data } = error;
  if (typeof data !== "object" || data === null) return fallback;
  if ("message" in data && typeof data.message === "string") return data.message;
  if ("error" in data && typeof data.error === "string") return data.error;
  return fallback;
}

export default apiErrorMessage;
